/**
 * Canonical moment type name constants.
 * Use these instead of hardcoding strings throughout the codebase.
 */

import { isEolMoment } from 'utils/constants';

export const MOMENT_TYPE_PRICE_CHANGES_AND_OFFERS = 'Price Changes and Offers';

/** Per-phase customer notification + effective dates and moment-level milestones (PCO, EOL). */
export function usesPcoStylePhasedDates(momentType?: string | null): boolean {
  return (
    momentType === MOMENT_TYPE_PRICE_CHANGES_AND_OFFERS ||
    isEolMoment(momentType)
  );
}

/** Milestones at moment root, not inside each release phase (PCO, EOL). */
export function usesMomentLevelMilestonesType(
  momentType?: string | null
): boolean {
  return usesPcoStylePhasedDates(momentType);
}
export const MOMENT_TYPE_NEW_1_0_RELEASE = 'New 1.0 Release';
export const MOMENT_TYPE_PRODUCT_RELEASE_WITH_MARKETING =
  'Product Release with Marketing';
export const MOMENT_TYPE_PRODUCT_RELEASE_WITHOUT_MARKETING =
  'Product Release without Marketing';
export const MOMENT_TYPE_MARKETING_MOMENT = 'Marketing Moment';
export const MOMENT_TYPE_KEY_DATES = 'Key Dates';
export const MOMENT_TYPE_EVENTS = 'Events';
